import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AddressBookDto, BankDto, IndividualAcreagesDto, LandTitleDto, LessorAreaMakerDto, LessorInfoDto, LessorRepresentativeDto, LessorRepTypeDto, LessorStakeholderDto, MeasureDto, OwnershipTypeDto, TerrainDto } from '@cradua/data';

@Component({
  selector: 'cradua-lessor',
  templateUrl: './lessor.component.html',
  styleUrls: ['./lessor.component.scss']
})
export class LessorComponent implements OnInit {
  @Input() activitySelectedValue: string;
  @Input() ownershipTypes: OwnershipTypeDto[];
  @Input() lessorInfos: LessorInfoDto[];
  @Input() lessorRepTypes: LessorRepTypeDto[];
  @Input() terrains: TerrainDto[];
  @Input() measures: MeasureDto[];
  @Input() banks: BankDto[];
  @Input() lessorAreaMakers: LessorAreaMakerDto[];
  @Input() addressBooks: AddressBookDto[];
  @Input() selectedLandTitle: LandTitleDto;
  @Input() lessorRepresentatives: LessorRepresentativeDto[];
  @Input() lessorStakeholders: LessorStakeholderDto[];
  @Input() individualAcreages: IndividualAcreagesDto[];
  @Input() isLoadingLessorRepresentative: boolean;
  @Input() isLoadingLessorStakeholder: boolean;
  @Input() isLoadingIndividualAcreages: boolean;
  @Input() isLoadingAddressBook: boolean;
  @Input() isLoadingLessorAreaMaker: boolean;
  @Output() emitAddressBook = new EventEmitter<any>();
  @Output() emitCreateAddressBook = new EventEmitter<any>();
  @Output() emitFindAddressBookById = new EventEmitter<any>();
  @Output() emitLessorAreaMaker = new EventEmitter<any>();
  @Output() emitLessorRepresentative = new EventEmitter<any>();
  @Output() emitLessorStakeholder = new EventEmitter<any>();
  @Output() emitIndividualAcreages = new EventEmitter<any>();

  @Output() emitLessorAreaMakerDelete = new EventEmitter<any>();
  @Output() emitLessorRepresentativeDelete = new EventEmitter<any>();
  @Output() emitLessorStakeholderDelete = new EventEmitter<any>();
  @Output() emitIndividualAcreagesDelete = new EventEmitter<any>();
  @Output() emitLessorInfoDelete = new EventEmitter<any>();

  selectedLessorInfo: LessorInfoDto;
  task = 'list';

  constructor() { }

  ngOnInit(): void {
  }

  onEmitLessorView(value: LessorInfoDto) {
    this.selectedLessorInfo = value;
    // this.emitFindAddressBookById.emit(value.AddressBookId);
    this.task = 'view';
  }

  onCreateAddressBook(value) {
    this.emitCreateAddressBook.emit(value)
  }

  onAddressBook(value) {
    this.emitAddressBook.emit(value);
  }

  onBack(task: string) {
    this.task = task;
  }

  onEmitLessorAreaMaker(value: LessorAreaMakerDto[]) {
    this.emitLessorAreaMaker.emit(value);
  }
  onEmitLessorRepresentative(value: LessorRepresentativeDto[]) {
    this.emitLessorRepresentative.emit(value);
  }
  onEmitLessorStakeholder(value: LessorStakeholderDto[]) {
    this.emitLessorStakeholder.emit(value);
  }
  onEmitIndividualAcreages(value: IndividualAcreagesDto[]) {
    this.emitIndividualAcreages.emit(value);
  }

  onEmitLessorAreaMakerDelete(value) {
    this.emitLessorAreaMakerDelete.emit(value);
  }
  onEmitLessorRepresentativeDelete(value) {
    this.emitLessorRepresentativeDelete.emit(value);
  }
  onEmitLessorStakeholderDelete(value) {
    this.emitLessorStakeholderDelete.emit(value);
  }
  onEmitIndividualAcreagesDelete(value) {
    this.emitIndividualAcreagesDelete.emit(value);
  }
  onEmitLessorInfoDelete(value) {
    this.emitLessorInfoDelete.emit(value);
  }


}
